import { render, staticRenderFns } from "./TreatmentImportResultModal.vue?vue&type=template&id=bf329f52"
import script from "./TreatmentImportResultModal.vue?vue&type=script&lang=js"
export * from "./TreatmentImportResultModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports